import { BaseModel } from '@tcc-mono/shared/data-access';
import { Relation } from './relation.model';
import { VionAnimal } from './vion-animal.model';

export type VionOrderStatus = 'draft' | 'final';

export class VionOrder extends BaseModel {
  id: number;
  order_number: string;
  status?: VionOrderStatus;
  relation_id: number;
  relation: Relation;
  vion_animals: VionAnimal[];
  extra_lines: Extraline[];
  delivery_date: string;
  total_price_incl_vat: number;
  total_price_ex_vat: number;
  email_sent?: string;
  weighing_slip_sent_at?: string;
  mail_status?: string;
  mail_status_invoice?: string;
  mail_status_weighing_slip?: string;
}

export class Extraline extends BaseModel {
  unit_price_ex_vat: number;
  total_price_ex_vat: number;
  vat_percentage: number;
  pcs: number;
  description: string;
}
